/* One finish preference shared by catalogue previews and product configuration. */
(() => {
  if (window.AK_PAPER_PREFS) return;
  const key='ak-paper-finish-v1';
  let memory=null;
  const normalize=value=>{
    if(!value || typeof value.frame!=='string' || typeof value.mount!=='string')return null;
    const mountChosen=value.chosen?.mount ?? true;
    return {frame:value.frame,mount:value.frame==='none'||!mountChosen?'none':value.mount==='creme'?'dark_creme':value.mount,chosen:{frame:true,mount:mountChosen}};
  };
  function read(){
    try {memory=normalize(JSON.parse(localStorage.getItem(key)))||memory;}catch(_){}
    if(!memory)try{const old=JSON.parse(sessionStorage.getItem('ak-catalog-preview-v1'));if(old?.chosen?.frame||old?.chosen?.mount)memory=normalize(old);}catch(_){}
    return memory;
  }
  function notify(source){window.dispatchEvent(new CustomEvent('ak:paper-finish-change',{detail:{selection:read(),source}}));}
  window.AK_PAPER_PREFS={read,write(value,source){const next=normalize(value);if(!next)return;const old=read();if(old?.frame===next.frame&&old?.mount===next.mount&&old?.chosen?.mount===next.chosen.mount)return;memory=next;try{localStorage.setItem(key,JSON.stringify(next));}catch(_){}notify(source);}};
  window.addEventListener('storage',event=>{if(event.key===key){memory=null;notify('storage');}});
})();
